import { render, staticRenderFns } from "./MembersFilteringCard.vue?vue&type=template&id=8b5bdb56&scoped=true&"
import script from "./MembersFilteringCard.vue?vue&type=script&lang=js&"
export * from "./MembersFilteringCard.vue?vue&type=script&lang=js&"
import style0 from "./MembersFilteringCard.vue?vue&type=style&index=0&id=8b5bdb56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5bdb56",
  null
  
)

export default component.exports